import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './PasswordField.css';

type State = any;

class PasswordField extends Component<any, State> {
  state = {
    isShowingAsText: false,
  };

  toggleVisibility = () => {
    const { isShowingAsText } = this.state;
    this.setState({
      isShowingAsText: !isShowingAsText,
    });
  };

  render() {
    const { className, ...rest } = this.props;
    const { isShowingAsText } = this.state;
    const inputType = isShowingAsText ? 'text' : 'password';

    return (
      <div className={styles.container}>
        <input
          {...rest}
          type={inputType}
          className={classNames(styles.input, className)}
        />
        <i
          onClick={this.toggleVisibility}
          className={classNames(styles.visibilityToggle, 'glyphicon', {
            'glyphicon-eye-open': isShowingAsText,
            'glyphicon-eye-close': !isShowingAsText,
          })}
        />
      </div>
    );
  }
}

export default PasswordField;
